import { mapActions, mapGetters } from 'vuex';
import storage_init from '../storage/grapes-init';
import Reveal from 'reveal.js/js/reveal';
const juice = require('juice');
import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
export default {
  computed: {
    ...mapGetters({
      deviceSize: 'common/getDeviceSize',
      selectedSlides: 'slides/getSelected',
      selectedSegments: 'segments/getSelectedSegments',
      paramsClient: 'getParamsClients',
      currentSegment: 'segments/getCurrent',
      currentSlide: 'slides/getCurrent',
      permission: 'getPermissions',
    }),
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  data() {},
  methods: {
    ...mapActions('common', ['setCanvasSize', 'duplicateSvgObject']),
    ...mapActions({
      setUrlMedia: 'setUrlMedia',
    }),
    getLangCode(plugin) {
      let plugins = Object.keys(storage_init.pluginsOpts);
      var p = plugins.filter((p, index) => {
        return p === plugin ? plugin : 'display-tides-plugin';
      });

      return { translate: i18n.t(plugin) };
    },
    makeId() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
    removeToolbarCkeditor() {
      if (document.querySelectorAll('.cke_reset_all')) {
        document.querySelectorAll('.cke_reset_all').forEach(element => {
          try {
            document.querySelector('.gjs-rte-toolbar').removeChild(element);
          } catch (e) {}
        });
      }
    },
    cmdInlineHtml(html, css) {
      css = css.split('body').join('.body');
      html = html.replace(/contenteditable/g, '');
      const tmpl =
        `<div class='body'>${html}</div>` +
        `<style>${css} .body{position: absolute;width: 100%;height: 100%;}</style>`;
      return juice(tmpl, {});
    },
    updateCanvasDimensions() {
      let x = this.deviceSize.x;
      let y = this.deviceSize.y;

      const canvasEl = document.querySelector('.gjs-cv-canvas');
      const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
      // Screens without a mounted GrapesJS editor (the segment list and the
      // segment metadata form) have no canvas, and the window resize handler
      // can also fire after the editor unmounts. Everything below - including
      // the deferred grapesjsEMP.editors[0] work - needs one, so bail out.
      if (!canvasEl || !iframeEl) return;
      const { offsetWidth, offsetHeight } = canvasEl;
      if (
        this.paramsClient.display_devices !== null &&
        this.paramsClient.display_devices[0] &&
        !!!this.paramsClient.display_devices[0].fixedSize
      ) {
        if (offsetWidth / offsetHeight < x / y) {
          iframeEl.style.width = 'calc(100% - 55px)';
          iframeEl.style.height = (offsetWidth - 55) * (y / x) + 'px';
        } else {
          iframeEl.style.height = offsetHeight - 30 + 'px';
          iframeEl.style.width = (offsetHeight - 30) * (x / y) + 'px';
        }
      } else {
        setTimeout(() => {
          iframeEl.style.width = this.paramsClient.display_devices[0].fixedSize.width + 'px';
          iframeEl.style.height = this.paramsClient.display_devices[0].fixedSize.height + 'px';
        }, 200);
      }

      setTimeout(() => {
        const canvasDimension = {
          width: parseFloat(window.getComputedStyle(iframeEl).width),
          height: parseFloat(window.getComputedStyle(iframeEl).height),
        };
        if (
          this.paramsClient.display_devices !== null &&
          this.paramsClient.display_devices[0] &&
          !!!this.paramsClient.display_devices[0].fixedSize
        ) {
          this.setCanvasSize(canvasDimension);
        } else {
          this.setCanvasSize(this.paramsClient.display_devices[0].fixedSize);
        }

        const editor = grapesjsEMP.editors[0];
        editor.getComponents().models.forEach(model => {
          if (model.attributes.type === 'facebook_widget') {
            model.view.updateScript();
            localStorage.setItem('gjs-js', editor.getJs());
          }
        });

        setTimeout(() => {
          grapesjsEMP.editors[0].trigger('change:canvasOffset');
          let height =
            (document.querySelector('.canvas-div').offsetHeight /
              (document.querySelector('.canvas-div .gjs-frame').offsetHeight + 60)) *
            100;
          let width =
            (document.querySelector('.canvas-div').offsetWidth /
              (document.querySelector('.canvas-div .gjs-frame').offsetWidth + 60)) *
            100;
          eventHub.$emit('updateDefaultValue', {
            percent:
              Math.min(height, width).toFixed(1) > 99 ? 100 : Math.min(height, width).toFixed(1),
            ty:
              Math.min(height, width).toFixed(1) > 99
                ? 0
                : document.querySelector('.canvas-div').offsetHeight -
                  document.querySelector('.canvas-div .gjs-frame').offsetHeight +
                  50,
          });
        }, 1000);
      }, 1000);
    },
    getScalingZoom() {
      let height =
        (document.querySelector('.canvas-div').offsetHeight /
          (document.querySelector('.canvas-div .gjs-frame').offsetHeight + 60)) *
        100;
      let width =
        (document.querySelector('.canvas-div').offsetWidth /
          (document.querySelector('.canvas-div .gjs-frame').offsetWidth + 60)) *
        100;
      return {
        percent: Math.min(height, width).toFixed(1) > 99 ? 100 : Math.min(height, width).toFixed(1),
        ty:
          Math.min(height, width).toFixed(1) > 99
            ? 0
            : document.querySelector('.canvas-div').offsetHeight -
              document.querySelector('.canvas-div .gjs-frame').offsetHeight +
              50,
      };
    },
    getScalingZoomAll() {
      let width16 = (document.querySelector('#editor').offsetHeight * 1280) / 720;
      let height = (document.querySelector('#editor').offsetHeight / (720 + 60)) * 100;
      let width = (width16 / (1280 + 60)) * 100;
      let min = Math.min(height, width) / 1.1;
      let tx = (document.querySelector('#editor').offsetWidth - (1280 * min) / 100) / 2;
      let ty = (document.querySelector('#editor').offsetHeight - (720 * min) / 100) / 2;
      return { percent: min.toFixed(1) > 99 ? 80 : min.toFixed(1), ty: ty, tx: tx };
    },
    scaleValue(customScale, size, ty = 0, tx = 0) {
      /* const sheetCanvas = new CSSStyleSheet();
      let self = this;


    /!*  ty = ty-self.ty(size);
      tx = tx-self.tx(size);*!/
       if(size*1 < 1 ){
         document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransitionNotResize');
       }
      if(size*1 < 1 && size*1 >=0.8 ){
        document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition-8');
        document.querySelector('.gjs-cv-canvas.customScale').classList.remove('customScaleTransition-7');
      }
      if(size*1 < 0.8 ){
        document.querySelector('.gjs-cv-canvas.customScale').classList.remove('customScaleTransition-8');
        document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition-7');
      }
      if(customScale == ".customScale"){
        const sheetCanvas2 = new CSSStyleSheet();
        let sizeToolbar = 1 + size > 1.5 ? 1.5 :1 + size;
        document.querySelector('.gjs-cv-canvas.customScale').classList.remove('customScaleTransition');
        sheetCanvas2.replaceSync(
          `.gjs-rte-toolbar  {
             transform: matrix(` +
          sizeToolbar +`, 0, 0,`+ sizeToolbar+`, ` +0+`, `+0+`
        )!important; } ` + customScale+`  { opacity:0.8;
             transform: matrix(` +
          size +`, 0, 0,`+ size+`, ` +0+`, `+0+`
        )!important; } `);
        document.adoptedStyleSheets = [sheetCanvas2];
        setTimeout(function(){
          document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition');
          ty = -self.ty(size) + 40;
        tx = -self.tx(size);

        sheetCanvas2.replaceSync(
          `.gjs-rte-toolbar  {
             transform: matrix(` +
          sizeToolbar +`, 0, 0,`+ sizeToolbar+`, ` +0+`, `+0+`
        )!important; } ` + customScale+`  {
             transform: matrix(` +
          size +`, 0, 0,`+ size+`, ` +tx+`, `+ty+`
        )!important; } `);
        document.adoptedStyleSheets = [sheetCanvas2];
        },100)

      }else {

        sheetCanvas.replaceSync(
          customScale+`  {
             transform: matrix(` +
          size +`, 0, 0,`+ size+`, ` +0+`, `+0+`
        )!important; } `);

        document.adoptedStyleSheets = [sheetCanvas];

        setTimeout(function(){
          document.querySelector('.gjs-cv-canvas.customScale').classList.add('customScaleTransition');
          ty = (ty-document.querySelector('.slidesParent').getBoundingClientRect().top);
          tx = (tx-document.querySelector('.slidesParent').getBoundingClientRect().left);

          sheetCanvas.replaceSync(
            customScale+`  {
             transform: matrix(` +
            size +`, 0, 0,`+ size+`, ` +tx+`, `+ty+`
        )!important; } `);

          document.adoptedStyleSheets = [sheetCanvas];
        },100)
      }*/
    },
    sanitizeCSS(css) {
      if (!css) {
        return '';
      }
      let styles = css.split('body').slice(1);
      if (styles.length <= 1) {
        return css;
      }
      let body = 'body' + styles[0];
      let other = styles[styles.length - 1];
      let rest = other.replace(other.substring(0, other.indexOf('}') + 1), '');
      return body + rest;
    },
    tx(parsent) {
      let transition_x = 0;
      if (
        document.querySelector('.gjs-cv-canvas.customScale') &&
        document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame')
      ) {
        let leftValue =
          (document.querySelector('.gjs-cv-canvas.customScale').offsetWidth -
            document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').offsetWidth * parsent) /
          2;
        if (leftValue < 0) leftValue = 0;
        transition_x =
          document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').getBoundingClientRect()
            .left - leftValue;
      }
      return transition_x;
    },
    ty(parsent) {
      let transition_y = 0;
      if (
        document.querySelector('.gjs-cv-canvas.customScale') &&
        document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame')
      ) {
        let topValue =
          (document.querySelector('.gjs-cv-canvas.customScale').offsetHeight -
            document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').offsetHeight *
              parsent) /
          2;
        if (topValue < 0) topValue = 0;
        transition_y =
          document.querySelector('.canvas-div .gjs-cv-canvas .gjs-frame').getBoundingClientRect()
            .top - topValue;
      }
      return transition_y;
    },
    getClone(slide) {
      const exceptions = [
        'newsTicker',
        'weather-grapes',
        'position',
        'hour',
        'min',
        'sec',
        'clock-grapes',
        'digital-clock',
      ];
      let ids = [];
      const parseObject = m => {
        const id = m.attributes.id;
        if (id && ids.indexOf(id) + exceptions.indexOf(id) < -1) {
          ids.push(id);
        }
        m.components.forEach(m => parseObject(m));
      };

      let components, js, html, css, styles;
      if (slide && slide.components) {
        const localStorageComponents = JSON.parse(slide.components);
        localStorageComponents.forEach(m => parseObject(m));
        components = slide.components;
        js = slide.js;
        html = slide.html;
        css = slide.css;
        styles = slide.styles;
      } else {
        const localStorageComponents = JSON.parse(localStorage.getItem('gjs-components'));
        localStorageComponents.forEach(m => parseObject(m));
        components = localStorage.getItem('gjs-components');
        js = localStorage.getItem('gjs-js');
        html = localStorage.getItem('gjs-html');
        css = this.sanitizeCSS(localStorage.getItem('gjs-css'));
        styles = localStorage.getItem('gjs-styles');
      }
      ids.forEach(id => {
        const newId = this.makeId();
        const re = new RegExp(id, 'g');

        /* duplicateSvgObject in store
           For Animation
         */
        let dataId = { oldid: id, newid: newId };
        this.duplicateSvgObject(dataId);
        //---------------------
        components = components.replace(re, newId);
        //js = js.replace(re, newId);
        html = html.replace(re, newId);
        css = css.replace(re, newId);
        styles = styles.replace(re, newId);
      });

      return {
        components,
        js,
        html,
        css,
        styles,
      };
    },
    getSegmentCloneThis(cloneThis) {
      let segment = Object.assign({}, cloneThis);
      segment.screens = segment.screens.map(screen => {
        if (screen.uid === this.currentSlide.uid) {
          screen = Object.assign({}, screen, this.getClone());
        } else {
          screen = Object.assign({}, screen, this.getClone(screen));
        }
        return screen;
      });
      return segment;
    },
    getSegmentClone() {
      let segment = Object.assign({}, this.currentSegment);
      segment.screens = segment.screens.map(screen => {
        if (screen.uid === this.currentSlide.uid) {
          screen = Object.assign({}, screen, this.getClone());
        } else {
          screen = Object.assign({}, screen, this.getClone(screen));
        }
        return screen;
      });
      return segment;
    },

    showViewContainer() {
      var self = this;
      this.$nextTick(() => {
        let index = 0;
        let interval = setInterval(() => {
          const blocks = document.querySelector(
            '.gjs-pn-panels .gjs-pn-panel.gjs-pn-views-container',
          );
          index++;
          if (blocks) {
            clearInterval(interval);

            const slideEl = document.querySelector('div#panel__left.show_panel');
            const canvasEl = document.querySelector('.canvas-div');
            let toggleButton = document.querySelector('.gjs-pn-panels #btn-toggle');
            let panelButtons = document.querySelector('.gjs-pn-panels .panel-buttons');
            var infos_new = document.getElementById('list-informations-new');

            let panelParams = [
              {
                icon: 'fa-bars',
                type: 'bars',
              },
              {
                icon: 'fa-th-large',
                type: 'large',
              },
              {
                icon: 'fa-paint-brush',
                type: 'brush',
              },
            ];
            let icons = panelParams.map(el => {
              return el.icon;
            });
            let types = panelParams.map(el => {
              return el.type;
            });

            types.forEach((type, index) => {
              const el = document.querySelector(
                '#gjs > div.gjs-editor.gjs-one-bg.gjs-two-color > div.gjs-pn-panels > div.gjs-pn-buttons.panel-buttons > span.gjs-pn-btn.fa.' +
                  icons[index],
              );

              if (el.classList.contains('gjs-pn-active')) {
                el.classList.add('isActiveBlocks');
              } else {
                el.classList.remove('isActiveBlocks');
              }
              el.addEventListener('click', function() {
                if (el.classList.contains('gjs-pn-active')) {
                  el.classList.add('isActiveBlocks');
                } else {
                  el.classList.remove('isActiveBlocks');
                }
                self.$root.$emit('show-panels-container');
              });
            });

            if (toggleButton) {
              toggleButton.addEventListener('click', () => {
                self.displayToggleButton(
                  blocks,
                  canvasEl,
                  slideEl,
                  panelButtons,
                  toggleButton,
                  infos_new,
                );
                setTimeout(() => {
                  this.updateCanvasDimensions();
                }, 150);
              });
              blocks.classList.remove('hide-blocks-panels');
              canvasEl.classList.remove('hide-canvas');
              panelButtons.classList.remove('hide-panel-buttons');
            }
          }
          if (index === 20) {
            clearInterval(interval);
          }
        }, 1000);
      });
    },

    displayToggleButton(blocks, canvasEl, slideEl, panelButtons, toggleButton, infos_new) {
      if (toggleButton.classList.contains('rotate-buttons')) {
        blocks.classList.remove('show-blocks-panels');
        canvasEl.classList.remove('show-canvas');
        panelButtons.classList.remove('show-panel-buttons');
        toggleButton.classList.remove('resize-panel-buttons');
        toggleButton.classList.remove('rotate-buttons');
        blocks.classList.remove('hide-blocks-panels');
        panelButtons.classList.remove('hide-panel-buttons');
        slideEl.classList.remove('hide_panel');
        if (!this.paramsClient.display_default_blocks) {
          if (!this.paramsClient.modules.show_list_block_action) {
            this.removeBlockPanelClasses(blocks, panelButtons, toggleButton);
          }
        } else if (
          this.paramsClient.display_default_blocks &&
          (Object.keys(this.paramsClient.display_default_blocks).length === 0 ||
            !this.paramsClient.modules.show_list_block_action)
        ) {
          this.removeBlockPanelClasses(blocks, panelButtons, toggleButton);
        }

        canvasEl.classList.remove('hide-canvas');

        infos_new.classList.remove('size-infos-new');
      } else {
        blocks.classList.remove('show-blocks-panels');
        canvasEl.classList.remove('show-canvas');
        panelButtons.classList.remove('show-panel-buttons');
        toggleButton.classList.remove('resize-panel-buttons');
        toggleButton.classList.add('rotate-buttons');
        blocks.classList.add('hide-blocks-panels');
        panelButtons.classList.add('hide-panel-buttons');
        slideEl.classList.add('hide_panel');
        if (!this.paramsClient.display_default_blocks) {
          if (!this.paramsClient.modules.show_list_block_action) {
            this.addBlockPanelClasses(blocks, panelButtons, toggleButton);
          }
        } else if (
          this.paramsClient.display_default_blocks &&
          (Object.keys(this.paramsClient.display_default_blocks).length === 0 ||
            !this.paramsClient.modules.show_list_block_action)
        ) {
          this.addBlockPanelClasses(blocks, panelButtons, toggleButton);
        }
        canvasEl.classList.add('hide-canvas');

        infos_new.classList.add('size-infos-new');
      }
    },
    removeBlockPanelClasses(blocks, panelButtons, toggleButton) {
      blocks.classList.remove('hide-block-panels');
      panelButtons.classList.remove('hide-panel-button');
      toggleButton.classList.remove('rotate-button');
    },
    addBlockPanelClasses(blocks, panelButtons, toggleButton) {
      blocks.classList.add('hide-block-panels');
      panelButtons.classList.add('hide-panel-button');
      toggleButton.classList.add('rotate-button');
    },
    setNoAutoplayVideo(editor) {
      let iframe = document.querySelector('.gjs-frame').contentWindow;
      let videoId;
      let autoplay;
      editor.getComponents().models.forEach(model => {
        let videoArray = ['video']; //, 'player', 'playlist'
        if (videoArray.indexOf(model.attributes.type) > -1) {
          videoId = model.attributes.attributes.id;
          autoplay = model.attributes.autoplay || model.attributes.attributes.autoplay;
          let videoSrc = model.attributes.attributes.src || model.attributes.src;
          let videoMuted = model.attributes.attributes.muted || model.attributes.muted;
          if (videoId) {
            let videoElIframe = iframe.document.querySelector('#' + videoId + ' > iframe');
            let videoEl = iframe.document.querySelector('#' + videoId + ' > video');
            if (videoElIframe) {
              videoElIframe.setAttribute('src', videoSrc);
            }
            if (videoEl) {
              if (autoplay === 1) {
                model.attributes.autoplay = autoplay;
                model.attributes.muted = videoMuted;
                videoEl.setAttribute('muted', videoMuted);
                videoEl.setAttribute('autoplay', '');
                videoEl.muted = true;
              }
            }
          }
        }
      });
    },
    setNoAutoplayDuplicateVideo(editor, videoId) {
      let iframe = document.querySelector('.gjs-frame').contentWindow;
      editor.getComponents().models.forEach(model => {
        let videoArray = ['video']; //, 'player', 'playlist'
        if (videoArray.indexOf(model.attributes.type) > -1) {
          let videoSrc = model.attributes.attributes.src || model.attributes.src;
          if (videoId) {
            setTimeout(function() {
              let videoEl = iframe.document.querySelector('#' + videoId + ' > iframe');
              if (videoEl) {
                videoEl.setAttribute('src', videoSrc);
              }
            }, 100);
          }
        }
      });
    },
    getSelectedSlides(type) {
      let listVideosObjects = [];
      let components;
      if (this.$route.name === 'segment' || this.$route.name === 'edit') {
        components = this.selectedSegments;
      } else {
        components = this.selectedSlides;
      }
      components.forEach((component, index) => {
        let comps;
        if (type === 'preview') {
          comps = JSON.parse(component.components);
        } else {
          comps = JSON.parse(localStorage.getItem('gjs-components'));
        }
        if (comps && Object.keys(comps).length > 0) {
          comps.forEach(comp => {
            comp.slide = JSON.parse(JSON.stringify(index));
            listVideosObjects.push(comp);
          });
        }
      });
      this.$root.$emit('AutoPlayVideoPreview', {
        video: JSON.parse(JSON.stringify(listVideosObjects)),
        type: type,
      });
    },
    setPausedVideo(type) {
      let timeout = 500;
      let iframe = document.querySelector('.gjs-frame').contentWindow;
      var items = iframe.document.querySelectorAll(
        "div[data-gjs-type='" + type + "'] > iframe, iframe[src*='autoplay=']", //, iframe[src*='autoplay=']
      );
      if (items.length > 0) {
        items.forEach(item => {
          this.setPausedPlayers(item, type, timeout);
        });
      }
    },
    setAutoplayPlayer(editor) {
      let i = 0;
      let videosArray = ['video', 'player', 'playlist'];
      let attrAutoplay;
      let interval = setInterval(() => {
        let iframe = document.querySelector('.gjs-frame').contentWindow;
        videosArray.forEach(video => {
          let playerItems = iframe.document.querySelectorAll(
            "div[data-gjs-type='" + video + "'] > iframe, iframe[src*='autoplay=']",
          );
          if (video === 'video') {
            attrAutoplay = 'autoplay';
          } else {
            attrAutoplay = 'a';
          }
          if (playerItems.length > 0) {
            playerItems.forEach(item => {
              if (item.getAttribute('src').indexOf(attrAutoplay + '=1') > -1) {
                this.setPlayedPlayers(item);
              } else {
                this.setPausedPlayers(item);
              }
            });
          }
        });
        i++;
        if (i === 5) {
          clearInterval(interval);
        }
      }, 1000);
    },
    setPausedVimeoVideo(p, video, timeout) {
      let i = 0;
      let nbr = 5;
      let interval = setInterval(() => {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.api('pause');
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    setPlayedVimeoVideo(p, video, timeout) {
      let i = 0;
      let nbr = 5;
      let interval = setInterval(() => {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.api('play');
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    setPausedPlayers(p, video, timeout) {
      let i = 0;
      let nbr = 1;
      if (video !== 'video') {
        nbr = 10;
      }
      let interval = setInterval(() => {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

          p.contentWindow.postMessage(
            {
              fn: 'launch_only_pause',
              params: [],
            },
            '*',
          );
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    setPlayedPlayers(p, video, timeout) {
      let i = 0;
      let nbr = 1;
      if (video !== 'video') {
        nbr = 10;
      }

      let interval = setInterval(() => {
        i++;
        if (i === nbr) {
          clearInterval(interval);
        }
        try {
          p.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

          p.contentWindow.postMessage(
            {
              fn: 'launch_only_play',
              params: [],
            },
            '*',
          );
        } catch (e) {
          console.error(e);
        }
      }, timeout);
    },
    getSanitizedHtml(html) {
      return html;
    },
    addModalUploadIframePlugin(id) {
      let self = this;
      let defaultUrls;
      let display;
      const div = document.createElement('div');
      div.id = id + '-iframe';
      div.style.display = 'none';
      defaultUrls = self.paramsClient.display_default_urls;
      if (defaultUrls) {
        let imageUrl;
        let urlMedia;
        let postInfos;
        let iframeHeight;
        if (id === 'image-media') {
          postInfos = 'showImage';
          iframeHeight = '500';
          imageUrl = defaultUrls.image_url;
          urlMedia = defaultUrls.url_media;
          self.setUrlMedia(urlMedia);
        }
        if (id === 'pattern') {
          postInfos = 'showImage';
          iframeHeight = '500';
          imageUrl = defaultUrls.pattern_url;
        }
        if (id === 'social-media') {
          imageUrl = self.paramsClient.display_default_urls.social_media_url;
          urlMedia = defaultUrls.url_social_media;
          postInfos = 'showSocialMedia';
          iframeHeight = '800';
        }
        let iframe =
          `<iframe width="100%" height="` +
          iframeHeight +
          `" frameborder="0" id="iframe-` +
          id +
          `" allow="autoplay;" allowfullscreen></iframe>`;
        if (imageUrl) {
          iframe = self.setIframePlugin(id, imageUrl, iframeHeight);
        }
        div.innerHTML =
          `<div class="gjs-mdl-container">
            <div id="gjs-mdl-dialog-` +
          id +
          `" class="gjs-mdl-dialog gjs-one-bg gjs-two-color" style="display: block;">
                  <div class="gjs-mdl-header modal-` +
          id +
          `">
                    <div class="gjs-mdl-title">` +
          i18n.t('blocks.select_' + id) +
          `</div>
                  <div id="close-modal-` +
          id +
          `" class="gjs-mdl-btn-close" data-close-modal="">⨯</div>
                  </div>
                  <div class="gjs-mdl-content modal-` +
          id +
          `"><div id="gjs-mdl-c-` +
          id +
          `">` +
          iframe +
          `</div>
                  <div style="clear:both"></div>
                    </div>
                    </div>
                    </div>`;
        document.body.appendChild(div);
      }
    },
    setIframePlugin(id, imageUrl, iframeHeight) {
      let iframe =
        `<iframe width="100%" height="` +
        iframeHeight +
        `" id="iframe-` +
        id +
        `"  src="` +
        imageUrl +
        `" frameborder="0" allow="autoplay;" allowfullscreen></iframe>`;
      return iframe;
    },
    setCloseImageModal(comp, id) {
      let self = this;
      if (document.getElementById('close-modal-' + id)) {
        document.getElementById('close-modal-' + id).addEventListener('click', function(e) {
          self.closeModal(comp, id);
        });
      }
    },
    closeModal(comp, id) {
      if (document.getElementById(id + '-iframe')) {
        document.getElementById(id + '-iframe').style.display = 'none';
      }
      if (document.getElementById('CanvOverlay')) {
        document.getElementById('CanvOverlay').style.display = 'none';
      }
      let obj = { info: 'closeModal' };
      if (document.getElementById('iframe-' + id)) {
        document.getElementById('iframe-' + id).contentWindow.postMessage(obj, '*');
      }
      this.handleEmptyPluginMedia(comp);
    },

    handleEmptyPluginMedia(comp) {
      let found = this.isCompFound(comp);
      while (found) {
        grapesjsEMP.editors[0].UndoManager.undo();
        found = this.isCompFound(comp);
      }
    },
    isCompFound(comp) {
      const getAllComponents = (model, result = []) => {
        result.push(model);
        model.components().each(mod => getAllComponents(mod, result));
        return result;
      };
      const all = getAllComponents(grapesjsEMP.editors[0].DomComponents.getWrapper());
      let found;
      if (comp === 'image_media' || comp === 'pattern') {
        found = all.some(c => c.attributes.type === comp && !c.attributes.src);
      }
      if (comp === 'social_media') {
        found = all.some(c => c.attributes.type === comp && !c.attributes.objectMedia.data);
      }
      return found;
    },
    convertHHMMSS(hms) {
      let a = hms.split(':'); // split it at the colons

      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      let seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
      return seconds;
    },
    triangleStyle(id, StyleDiv, px) {
      // Create our stylesheet:
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(
        id +
          `:before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        left: ` +
          px +
          `px;
        box-sizing: border-box;
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 15px solid #f8f9fa;
        margin-left: -25px;
        transform:` +
          StyleDiv +
          `;
      }
       `,
      );
      // Apply the stylesheet
      document.adoptedStyleSheets = [sheet];
    },
    getNbSreenSegment() {
      return Number.isInteger(parseInt(this.permission.nb_screen_segment));
    },

    ShowToolBar(icon) {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('div.fa.fa-' + icon + '.gjs-toolbar-item{ display:Block; } ');
    },
    displayToolBar(icon) {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('div.fa.fa-' + icon + '.gjs-toolbar-item{ display:none; } ');
    },
    showHideToolBars(icon) {
      document
        .querySelector('div.fa.fa-' + icon + '.gjs-toolbar-item ')
        .setAttribute('style', 'display:none');
      this.eventComponentUpdate(this.editor);
    },
    displayImgBGToolBar() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('.reset-full-BG{ display:none; } ');
    },
    showImgBGToolBars() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      style.sheet.insertRule('.reset-full-BG{ display:Block; } ');
    },
    animationAttributesToClass(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const elements = doc.querySelectorAll('div');

      elements.forEach(el => {
        const animation = el.getAttribute('data-animation');
        if (animation) {
          animation.split(' ').forEach(a => {
            el.classList.add(a);
          });
        }
      });

      return doc.documentElement.innerHTML;
    },
    updateAlignement() {
      setTimeout(() => {
        const model = grapesjsEMP.editors[0].getSelected();
        if (model) {
          const iframeEl = document.querySelector('.gjs-frame');
          const iframeWidth = iframeEl.getBoundingClientRect().width;
          if (model.view) {
            const modelWidth = model.view.el.getBoundingClientRect().width;
            const modelLeft = model.view.el.getBoundingClientRect().left;
            
            const leftEl = (modelLeft / iframeWidth) * 100;
            const rightEl = (1 - (modelLeft + modelWidth) / iframeWidth) * 100;

            const alignment = leftEl < rightEl ? 'left' : 'right';
            document.getElementById('float-' + alignment)
              ? (document.getElementById('float-' + alignment).checked = true)
              : null;
          }
        }
      }, 100);
    },
    getDuration(duration) {
      let fact1 = '';
      let fact2 = '';
      if (Math.floor(duration / 60) < 10) {
        fact1 = '0' + Math.floor(duration / 60);
      } else {
        fact1 = Math.floor(duration / 60);
      }
      if (duration % 60 < 10) {
        fact2 = '0' + (duration % 60);
      } else {
        fact2 = duration % 60;
      }
      if (duration < 60) {
        return '00:' + fact2;
      } else {
        return fact1 + ':' + fact2;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/Mixin.js